import { v4 as uuidv4 } from "uuid";

import { CustomLabel } from "pro-features/components/Chart/src/components/column/CustomLabel";
import type { ColumnChartDataItems, IColumnChartDataItem } from "pro-features/components/Chart/src/types";
import { translate } from "app/filters/i18nFilter";
import { sum } from "app/filters/ngFilters";
import { COMMON_COLORS } from "app/pages/industry-analysis/common/commonColors";

export const getChartDataViewView = (
    chartData: ColumnChartDataItems,
    columnsToDisplay: number,
    labelFormatter: (y: number) => string,
    displayOthersColumn = true,
): ColumnChartDataItems => {
    const chartDataView: ColumnChartDataItems = [];
    chartData.forEach((dataItem, index) => {
        const originalColor = dataItem.color;
        const maxColumnLength = displayOthersColumn ? columnsToDisplay - 1 : columnsToDisplay;

        if (chartDataView.length < maxColumnLength) {
            const color = index === 0 ? COMMON_COLORS.BLUE : COMMON_COLORS.LIGHT_BLUE;
            chartDataView.push({ ...dataItem, color: originalColor ?? color });
        } else {
            const hasOthersColumn = chartDataView.length > columnsToDisplay - 1;
            if (!hasOthersColumn && displayOthersColumn) {
                chartDataView.push({
                    y: 0,
                    color: COMMON_COLORS.OTHER_CHART,
                    displayText: translate("common.others"),
                } as IColumnChartDataItem);

                const others = chartDataView[chartDataView.length - 1];

                others.y = sum(others.y, dataItem.y);
            }
        }
    });

    const enrichedChartDataView: ColumnChartDataItems = chartDataView.map((dataItem) => {
        const displayText = dataItem.displayText;
        const subDisplayText = dataItem.subDisplayText;
        const y = dataItem.y;
        const className = uuidv4();
        const renderLabel = () => {
            return (
                <CustomLabel
                    displayText={displayText}
                    subDisplayText={subDisplayText}
                    value={labelFormatter(y)}
                />
            );
        };
        return { ...dataItem, renderLabel, className };
    });
    return enrichedChartDataView;
};
